import {useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import {useErrorModal} from 'hooks';
import {useKioskoStore} from 'context/kiosko/useKioskoStore';

function KioskoErrorModal() {
  const {displayError, ErrorModal} = useErrorModal();
  const {t} = useTranslation();
  const errorStatus = useKioskoStore(state => state.scanner.error);

  useEffect(() => {
    if (errorStatus) {
      displayError({title: t('error'), message: errorStatus});
    }
  }, [errorStatus, displayError, t]);
  return <ErrorModal />;
}

export {KioskoErrorModal};
